<div class="hub-edit-program-outcomes-container">
    <ul class="nav nav-tabs nav-tabs-bottom mb-0">
        <li class="nav-item">
            <a href="#" (click)="setTabTo(tabs.linkedOutcomes, $event)" class="nav-link"
                [ngClass]="{active: activeTab === tabs.linkedOutcomes}">Linked Outcomes</a>
        </li>
        <li class="nav-item">
            <a href="#" (click)="setTabTo(tabs.goalTargets, $event)" class="nav-link"
                [ngClass]="{active: activeTab === tabs.goalTargets}">2030 Goal and Metric Targets</a>
        </li>
    </ul>

    <div class="tab-content">
        <div class="tab-pane fade p-0" [ngClass]="{active: activeTab === tabs.linkedOutcomes, show: activeTab === tabs.linkedOutcomes}">
            <app-linked-outcomes-panel></app-linked-outcomes-panel>
        </div>

        <div class="tab-pane fade active p-0" [ngClass]="{active: activeTab === tabs.goalTargets, show: activeTab === tabs.goalTargets}">
            <app-goal-targets-panel></app-goal-targets-panel>
        </div>
    </div>
</div>
